






















































import {Component, Vue, Config, BasePage} from '@/common';
import offerEdit from './components/offerEdit.vue';
import {TwTable} from '@/components';

@Component({
	components: {
		offerEdit
	}
})
export default class offer extends BasePage {
	get table(): TwTable {
		return this.$refs['table'] as TwTable;
	}

	rowGuid = '';
	showEdit = false;
	columns = [];
	CUSTOM_NAME = [];

	searchMode = {
		CUSTOM_NAME: '',
		CREATE_DATE_FROM: null,
		CREATE_DATE_TO: null
	};

	ok() {
		this.table.reload();
	}

	add() {
		this.rowGuid = '';
		this.showEdit = true;
	}


	refresh() {
		this.table.load({...this.searchMode});
	}

	dbClick(row) {
		this.showEdit = true;
		this.rowGuid = row.GUID;
	}

	deleteRows() {
		this.$confirm('此操作将永久删除该数据以及明细, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		})
			.then(() => {
				this.$http
					.post('Biz/Offer/Delete', {
						GUID: this.table.getSelections().map(item => item.GUID)
					})
					.then(res => {
						if (res.data.status === 0) {
							this.$message.success('删除成功');
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	mounted() {
		this.buildColumn('002002', this.columns);
		this.loadCustom();
	}

	loadCustom() {
		this.$http.get('Biz/Offer/GetCustom').then(res => {
			if (res.data.status === 0) {
				this.CUSTOM_NAME.splice(0);
				this.CUSTOM_NAME.push(...res.data.CUSTOMINFO);
			}
		});
	}
}
